import { apiClient } from './client.ts';

export interface RegisterPayload {
  platform: 'max' | 'telegram';
  initData: string;
  phone?: string;
}

export type RegisterResponse =
  | { requiresPhone: true }
  | {
      requiresPhone: false;
      token: string;
      userId: string;
      isApproved: boolean;
      isNew: boolean;
      role: 'owner' | 'admin';
      needsOnboarding: boolean;
    };

export async function register(payload: RegisterPayload): Promise<RegisterResponse> {
  return apiClient.post('auth/register', { json: payload }).json<RegisterResponse>();
}

export interface OnboardingPayload {
  fullName: string;
  buildingNumber: number;
}

export interface OnboardingResponse {
  houseId: string;
  buildingNumber: string;
}

export async function completeOnboarding(
  payload: OnboardingPayload
): Promise<OnboardingResponse> {
  return apiClient.post('onboarding', { json: payload }).json<OnboardingResponse>();
}
